import { PersistedState } from 'redux-persist';
export const runMigration = async (state: PersistedState) => {
  return state;
};
